import React from "react";
import { diff_match_patch } from "diff-match-patch";
import PropTypes from "prop-types";

const styles = {
  added: {
    color: "green",
    backgroundColor: "#b5efdb",
  },
  removed: {
    color: "red",
    backgroundColor: "#fec4c0",
    textDecoration: "line-through",
  },
};

const DMP = ({ string1 = "", string2 = "", cleanUp = "semantic", editCost = 4 }) => {
  const dmp = new diff_match_patch();

  const diff = dmp.diff_main(string1, string2);
  if (cleanUp === "semantic") dmp.diff_cleanupSemantic(diff);

  const mappedNodes = diff.map((group: any[], idx) => {
    const key = group[0];
    let value = group[1];

    let nodeStyles;
    if (key === 1) nodeStyles = styles.added;
    if (key === -1) nodeStyles = styles.removed;

    if (/^<[^>]+>$/.test(value)) {
      return (
        <span key={idx} style={nodeStyles}>{value}</span>
      );
    }

    function replaceHTMLEncoders(value: any): React.ReactNode {
      return value
        .replace(/&amp;/g, "&")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/<p><br><\/p>/g, '\n')
        .replace(/<br\s*\/?>/g, '\n');
    }

    value = replaceHTMLEncoders(value)

    value = value.split("\n").map((line: string, lineIdx: number, lines: string[]) => (
      <React.Fragment key={lineIdx}>
        {line}
        {lineIdx < lines.length - 1 && (
          <>
            {"⏎"}
            <br/>
          </>
        )}
      </React.Fragment>
    ));

    return <span key={idx} style={nodeStyles}>{value}</span>;
  });

  return (
    <div style={{overflowY: 'auto', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
      {mappedNodes}
    </div>
  );
};

DMP.propTypes = {
  string1: PropTypes.string,
  string2: PropTypes.string,
  mode: PropTypes.oneOf(["characters", "words"])
};

export default DMP;
